import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import ConfirmDialog from 'components/ConfirmDialog'
import { calendarTimestamp } from 'helpers'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, primaryColor } from '../Styles'

const NotificationsScreen = props => {
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Notificaciones ({props.notificationsUnreadCount()})</Typography>
          </div>
          <div className="right">
            <CheckCircleIcon
              className={props.classes.btMarkAllAsRead}
              onClick={props.openMarkAllNotificationsAsReadDialog}
            />
            <ConfirmDialog
              title="Marcar todas como leídas"
              open={props.markAllNotificationsAsReadDialogOpen}
              onOk={() => props.markAllNotificationsAsRead()}
              onCancel={() => props.closeMarkAllNotificationsAsReadDialog()}>
              ¿Estás seguro de qué deseas marcar todas las notificaciones como leídas?
            </ConfirmDialog>
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.notifications}>
        <Grid container>
          {props.notifications &&
            props.notifications.map((notification, key) => (
              <Grid
                key={key}
                item
                xs={12}
                sm={6}
                md={4}
                className={props.classes.notification}
                onClick={() => {
                  props.markNotificationAsRead(notification.id)
                  if (notification.frontendMethodName) {
                    props[notification.frontendMethodName](
                      notification.frontendMethodParam1,
                      notification.frontendMethodParam2,
                    )
                  }
                }}>
                <Typography className={props.classes.notificationTitle}>
                  {!notification.read_at && <div className={props.classes.notificationUnreadIndicator} />}
                  {notification.title}
                </Typography>
                <Typography className={props.classes.notificationBody}>{notification.body}</Typography>
                <Typography className={props.classes.notificationDate}>
                  {calendarTimestamp(notification.created_at)}
                </Typography>
              </Grid>
            ))}
        </Grid>
      </div>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  btMarkAllAsRead: {
    padding: 10,
    color: '#FFF',
    cursor: 'pointer',
  },
  notifications: {},
  notification: {
    padding: 10,
    borderRight: '1px solid #DDD',
    borderBottom: '1px solid #DDD',
    cursor: 'pointer',
  },
  notificationUnreadIndicator: {
    display: 'inline-block',
    background: primaryColor,
    borderRadius: '50%',
    width: 10,
    height: 10,
    marginRight: 5,
  },
  notificationTitle: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  notificationBody: {
    fontSize: 12,
  },
  notificationDate: {
    marginTop: 2,
    fontSize: 11,
    color: '#777',
  },
}

export default withStyles(styles)(NotificationsScreen)



// WEBPACK FOOTER //
// ./src/screens/NotificationsScreen.js